export default __webpack_public_path__ + "static/media/mercado.922270cb.png";